import { FormattedMessage } from "react-intl";

import Detail from "../../components/registration/detail";
import BaseDataDetail from "../../components/app/generic/baseDataDetail";

const Registration = ({ contract, oldPassword, onContractLoad }) => (
  <BaseDataDetail
    listPath="/"
    detail={Detail}
    data={contract}
    onDataLoad={onContractLoad}
    detailOptions={{ oldPassword }}
    listTitle={
      <FormattedMessage id="registration.detail.goBack" defaultMessage="Zpět" />
    }
    title={
      <FormattedMessage
        id="registration.description"
        defaultMessage="Registrace nového klienta"
      />
    }
  />
);

export default Registration;
